module.exports = __webpack_public_path__ + "static/media/Video-Homily-Notes.5c27b7d6.docx";